import moment from 'moment';
import { ItemHistorizable } from '../../shared/models/itemHistorizable';
import { IntensityDto } from './intensity.dto';

export class BeneficiaryIntensityDto implements ItemHistorizable {
  public id: number;
  public beginDate: Date;
  public endDate: Date;
  public intensity: IntensityDto;
  public beneficiaryId: number;
  public historized: boolean;

  public static fromJson(json: any): BeneficiaryIntensityDto {
    if (!json) {
      return null;
    }
    return {
      id: json.id,
      beginDate: json.beginDate ? moment(json.beginDate).toDate() : undefined,
      endDate: json.endDate ? moment(json.endDate).toDate() : undefined,
      intensity: IntensityDto.fromJson(json.intensity),
      beneficiaryId: json.beneficiaryId,
      historized: json.historized,
    } as BeneficiaryIntensityDto;
  }
}
